import React, { useRef, useState } from "react";
import { LoginInput } from "./loginInput";
import { LuMailCheck } from "react-icons/lu";
import { GoMail } from "react-icons/go";
import { recoverPassword } from "../../api/login";

export const FormRecover = () => {
  const [emailSended, setEmailSended] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const inFlight = useRef(false);
  const handleRecover = async () => {
    if (inFlight.current) return;
    const input = document.getElementById("recoverEmailInput");
    const email = input.value.trim();
    if (!email || !input.validity.valid) {
      setError("Introduce un email válido para recuperar tu acceso.");
      return;
    }
    inFlight.current = true;
    setPending(true);
    setError("");
    try {
      const response = await recoverPassword({ email });
      if (response?.error === false) setEmailSended(true);
      else setError("No se ha podido enviar el enlace. Comprueba el email y vuelve a intentarlo.");
    } catch {
      setError("No se ha podido enviar el enlace. Revisa la conexión y vuelve a intentarlo.");
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  };

  return !emailSended ? (
    <form noValidate aria-busy={pending} onSubmit={event => { event.preventDefault(); handleRecover(); }}>
      <label className="labelLogin" htmlFor="recoverEmailInput">Email</label>
      <LoginInput id="recoverEmailInput" type="email" required disabled={pending} icon={<GoMail />} classname="w-100" />
      {error && <div className="errorValue errorMessage" role="alert">{error}</div>}
      <button type="submit" className="button-1 mt-2 loginSubmit" disabled={pending}>
        {pending ? "Enviando enlace…" : "Enviar enlace de recuperación"}
      </button>
    </form>
  ) : (
    <div className="accessSuccess" role="status"><LuMailCheck aria-hidden="true" /><strong>Revisa tu correo</strong><p>Se ha enviado un enlace de restablecimiento al email especificado.</p><p>Abre el enlace para crear tu nueva contraseña. Si no lo encuentras, revisa la carpeta de spam.</p></div>
  );
};
